<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">ATM</div>
    <div class="nova__dialog__toolbar__controls">
        <button class="nova__button--icon" (click)="close()">
            <mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon>
        </button>
    </div>
</div>
<div mat-dialog-content class="atm-form-container">
    <form [formGroup]="atmForm">
        <div class="flex-row">
            <ng-container *ngIf="existingJobId">
                <div class="atm-edit-data" aria-label="ATM Job Id"><span class="text-label">Job Id:</span>{{existingJobId}}</div>
            </ng-container>
            <ng-container *ngIf="!existingJobId">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Job Id</mat-label>
                    <input matInput
                           aria-label="ATM Job Id"
                           type="number"
                           formControlName="jobId">
                    <mat-error *ngIf="targetMargin.errors?.['required']">Job Id is required</mat-error>
                    <mat-error *ngIf="targetMargin.errors?.['min']">Job Id must be greater than 0</mat-error>
                </mat-form-field>
            </ng-container>
        </div>
        <div class="flex-row">
            <mat-form-field appearance="outline" class="text-suffix target-margin-field">
                <mat-label>Target Margin</mat-label>
                <input matInput
                       data-qa-id="AtmValue"
                       aria-label="ATM Value"
                       type="number"
                       formControlName="targetMargin">
                <span matSuffix>&percnt;</span>
                <mat-error *ngIf="targetMargin.errors?.['required']">Target Margin is required</mat-error>
                <mat-error *ngIf="targetMargin.errors?.['min']">Target Margin must be greater than 0</mat-error>
                <mat-error *ngIf="targetMargin.errors?.['max']">Target Margin must be less than 101</mat-error>
            </mat-form-field>
        </div>
    </form>
    <mat-dialog-actions class="nova__dialog__content__actions" align="end">
        <button mat-raised-button
                color="primary"
                (click)="saveHandler()"
                [disabled]="isSaveDisabled()">
            Save ATM
        </button>
    </mat-dialog-actions>
</div>
